import { apiClientGeral } from '@/plugins/axios'
import { hostname } from '@/utils/hostname'

export default {
  listarTags() {
    return apiClientGeral().get('/relatorios/pabx/tags/lazy')
  },
  listarRamais() {
    return apiClientGeral().get('/relatorios/pabx/ramais/lazy')
  },
  listarCentroDeCustos() {
    return apiClientGeral().get('/centrodecusto/lazy')
  },
  listarConferencias() {
    return apiClientGeral().get('/relatorios/conferencia/conferencias/lazy')
  },
  buscarDadosRelatorio(form, page) {
    return apiClientGeral().post(`/relatorios/pabx?_method=GET&page=${page}`, form)
  },

  exportExcel(params) {
    let query = `dataHoraInicio=${encodeURI(params.dataHoraInicio)}&dataHoraFim=${encodeURI(params.dataHoraFim)}`

    if(params.numeroOrigem.length == 0){
      query = `${query}&numeroOrigem[]=${params.numeroOrigem}`
    }else{
      params.numeroOrigem.forEach(origem => {
        query = `${query}&numeroOrigem[]=${origem}`
      })
    }

    if(params.numeroDestino.length == 0){
      query = `${query}&numeroDestino[]=${params.numeroDestino}`
    }else{
      params.numeroDestino.forEach(destino => {
        query = `${query}&numeroDestino[]=${destino}`
      })
    }

    if(params.centroDeCusto.length == 0){
      query = `${query}&centroDeCusto[]=${params.centroDeCusto}`
    }else{
      params.centroDeCusto.forEach(centroDeCusto => {
        query = `${query}&centroDeCusto[]=${centroDeCusto}`
      })
    }
    
    if(params.status.length == 0){
      query = `${query}&status[]=${params.status}`
    }else{
      params.status.forEach(status => {
        query = `${query}&status[]=${status}`
      })
    }

    if(params.tags.length == 0){
      query = `${query}&tags[]=${params.tags}`
    }else{
      params.tags.forEach(tags =>{
        query = `${query}&tags[]=${tags}`
      })
    }

    if(params.ramais.length == 0){
      query = `${query}&ramais[]=${params.ramais}`
    }else{
      params.ramais.forEach(ramais => {
        query = `${query}&ramais[]=${ramais}`
      })
    }
    if(params.protocol.length == 0){
      query = `${query}&protocol[]=${params.protocol}`
    }else{
      params.protocol.forEach(protocol => {
        query = `${query}&protocol[]=${protocol}`
      })
    }

    const token = window.localStorage.getItem('pcm_access_token')
    query = `${query}&token=${token}`

    return `https://${hostname()}/backend/asterisk/relatorios/pabx/export?${query}`
  },
}
